import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { fetchBootstrapEffect } from 'app/store/Auth/effects';
import { setUser, getCurrentHub } from '@sentry/react';

export function sentryMiddleware() {
  return (next: Dispatch) => (action: AnyAction) => {
    const currentHub = getCurrentHub();
    const isInitialized = Boolean(currentHub.getClient());
    const result = next(action);
    if (!isInitialized) {
      return result;
    }

    if (action.type === 'auth/logout') {
      setUser(null);
    }

    if (action.type === `${fetchBootstrapEffect.typePrefix}/fulfilled`) {
      const userGuid = action.payload?.account?.userGuid;
      if (userGuid) {
        setUser({ id: userGuid });
      } else {
        setUser(null);
      }
    }

    return result;
  };
}
